import { Axios } from "utils";

export const getProgramForAttendance = async () => {
  const res = await Axios.get(`v2/portal/Programs/studentbatches/select-list`);
  return res.data;
};

export const getAttendanceDate = async (studentBatchId, month, year) => {
  const res = await Axios.get(
    `/v2/portal/Programs/attendance/${studentBatchId}/dates?month=${month}&year=${year}`
  );
  return res.data;
};

export const getBatchValidityDate = async (studentBatchId) => {
  const res = await Axios.get(`v2/portal/Programs/${studentBatchId}/validity`);
  return res.data;
};

export const getAttendanceCheck = async ({ studentBatchId }) => {
  const res = await Axios.get(
    `v2/portal/Programs/attendance/${studentBatchId}/check`
  );
  return res.data;
};
